export const Ach = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} className="w-full">
		<path
			d="M7.78147 2.04484C7.92099 1.98505 8.07891 1.98505 8.21843 2.04484L12.4537 3.85997C12.7353 3.98063 12.8657 4.30668 12.745 4.58822C12.6244 4.86977 12.2983 5.00019 12.0168 4.87953L7.99995 3.15803L3.98313 4.87953C3.70159 5.00019 3.37554 4.86977 3.25488 4.58822C3.13421 4.30668 3.26464 3.98063 3.54618 3.85997L7.78147 2.04484Z"
			fill="currentColor"
		/>
		<path
			d="M6.13445 9.21008C6.13445 8.90377 5.88614 8.65546 5.57983 8.65546C5.27352 8.65546 5.02521 8.90377 5.02521 9.21008V11.0252C5.02521 11.3315 5.27352 11.5798 5.57983 11.5798C5.88614 11.5798 6.13445 11.3315 6.13445 11.0252V9.21008Z"
			fill="currentColor"
		/>
		<path
			d="M8 8.65546C8.3063 8.65546 8.55462 8.90377 8.55462 9.21008V11.0252C8.55462 11.3315 8.3063 11.5798 8 11.5798C7.69369 11.5798 7.44537 11.3315 7.44537 11.0252V9.21008C7.44537 8.90377 7.69369 8.65546 8 8.65546Z"
			fill="currentColor"
		/>
		<path
			d="M10.9748 9.21008C10.9748 8.90377 10.7265 8.65546 10.4202 8.65546C10.1139 8.65546 9.86555 8.90377 9.86555 9.21008V11.0252C9.86555 11.3315 10.1139 11.5798 10.4202 11.5798C10.7265 11.5798 10.9748 11.3315 10.9748 11.0252V9.21008Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.55462 6.2353C2.24831 6.2353 2 6.48361 2 6.78992C2 7.09623 2.24831 7.34454 2.55462 7.34454H2.60504V12.8908H2.55462C2.24831 12.8908 2 13.1391 2 13.4454C2 13.7517 2.24831 14 2.55462 14H3.15805L3.15966 14L3.16128 14H12.8387L12.8403 14L12.842 14H13.4454C13.7517 14 14 13.7517 14 13.4454C14 13.1391 13.7517 12.8908 13.4454 12.8908H13.395V7.34454H13.4454C13.7517 7.34454 14 7.09623 14 6.78992C14 6.48361 13.7517 6.2353 13.4454 6.2353H2.55462ZM12.2857 7.34454V12.8908H3.71429V7.34454H12.2857Z"
			fill="currentColor"
		/>
	</svg>
);
